export default __webpack_public_path__ + "static/media/DeepDAOTermsofUse.458da360.pdf";